import * as React from 'react';

import { Toggle, ToggleButtonGroup } from '@rematter/ui-web';
import { useAtom } from 'jotai';

import { useTranslations } from '../../../i18n/useTranslations';

import { $ticketDirection } from '~/modules/trade/_state/scaleTicketPro.state';
import { TicketDirection } from '~/modules/trade/types/scaleTickets';

//
// ⚛️ ⚛️ ⚛️ DIRECTION TOGGLE ⚛️ ⚛️ ⚛️
//
export const DirectionToggle = () => {
  // Translations
  const t = useTranslations();

  // Atoms
  const [direction, setDirection] = useAtom($ticketDirection);

  // Callbacks
  const handleChange = React.useCallback(
    (keys: Set<React.Key>) => {
      const first = [...keys][0];
      if (first) {
        setDirection(first as TicketDirection);
      }
    },
    [setDirection],
  );

  return (
    <ToggleButtonGroup
      selectionMode="single"
      selectedKeys={new Set([direction])}
      onSelectionChange={handleChange}
      className="@DirectionToggle"
    >
      <Toggle id="inbound" size="xl">
        {t.scaleTicketPro.inbound}
      </Toggle>
      <Toggle id="outbound" size="xl">
        {t.scaleTicketPro.outbound}
      </Toggle>
    </ToggleButtonGroup>
  );
};
